import React from 'react';
import { UALProvider } from 'ual-reactjs-renderer';
import {Helmet} from "react-helmet";
import { anchor, wax, myChain, currentWebsiteURL,  wombat, APP_NAME } from '../data/config';
import "./homepage-styles.css"
import { NewListingBody, NewListingCont, SocialsButton, TallFiltersCont, TallFiltersInnerCont } from '../Styles';
import { SocialButton } from '../components/LeftDiv';

const Support = () => {

  return (
  <div id="seo">
    <Helmet>
    <title>Support - WaxDAO Names</title>
    <meta name="description" content="Contact us - WaxDAO name service" />
    <link rel="canonical" href={`${currentWebsiteURL}/faq`} />
    </Helmet>

    <UALProvider chains={[myChain]} authenticators={[anchor, wax, wombat]} appName={APP_NAME}>

    <NewListingCont>
        <NewListingBody>
            <TallFiltersCont>
                <h2>Support</h2>
            </TallFiltersCont>
            
            <div className='text-center justify-center items-center w-100'>
            <a href="https://discord.gg/xdvn5dkqvP" target="none">
            <SocialsButton>
                Discord
            </SocialsButton>
            </a>

            <a href="https://t.me/hoodpunks" target="none">
            <SocialsButton>
                Telegram
            </SocialsButton>   
            </a>

            <a href="https://twitter.com/waxdao_io" target="none">
            <SocialsButton>
                Twitter
            </SocialsButton>   
            </a>            
            </div>


        </NewListingBody>
    </NewListingCont>







    </UALProvider>
    <br/><br/><br/>
    </div>
  )
}

export default Support